import Language from '../../app/Language.enum'

export const getTranslationGql = (field: string) => `
${field} {
  ${Language.En}
  ${Language.Fr}
}
`
